// Errors the app treats as expected: an ended session (the user is sent to the login page) and a
// gateway outage (the user gets the "try again" screen). The error fallback uses these to pick
// what to show, and error reporting (DD-3735) drops them, since neither is a bug in the UI.

const SESSION_ERROR_MESSAGES = ['Access denied', 'jwt expired'];
const GATEWAY_ERROR_MESSAGE = 'Bad Gateway';

export const isSessionErrorMessage = (message?: string): boolean =>
    !!message && SESSION_ERROR_MESSAGES.some((expected) => message.includes(expected));

export const isGatewayErrorMessage = (message?: string): boolean =>
    !!message && message.includes(GATEWAY_ERROR_MESSAGE);

export const isExpectedErrorMessage = (message?: string): boolean =>
    isSessionErrorMessage(message) || isGatewayErrorMessage(message);
